'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable max-len */
exports.default = {
  header: '',
  item: '<label class="{{cssClasses.label}}">\n  <input type="radio" class="{{cssClasses.radio}}" name="{{attributeName}}" {{#isRefined}}checked{{/isRefined}} />{{name}}\n</label>',
  footer: ''
};


// WEBPACK FOOTER //
// ./~/instantsearch.js/dist-es5-module/src/widgets/numeric-refinement-list/defaultTemplates.js